import type { GTMEcommerceReturnType, GTMItemData, GTMItemsReturnType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

interface GTMAddToWishlistEcommerceReturnType {
    items: Pick<GTMItemsReturnType, 'item_id'>[];
}

interface GTMAddToWishlistModelData extends Pick<GTMItemData, 'id'> {}

export default class GTMAddToWishlistModel extends GTMBaseModel {
    public static parseToGTMData({
        id
    }: GTMAddToWishlistModelData): GTMEcommerceReturnType<GTMAddToWishlistEcommerceReturnType> {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'web_event',
            ga4_event_name: 'add_to_wishlist',
            ecommerce: {
                items: [
                    {
                        item_id: id
                    }
                ]
            }
        };
    }
}
